export default "__VITE_ASSET__B927EdLI__"